<nav class="navbar shadow navbar-expand-md navbar-light bg-white" style="margin-top: 25px;">
  <div class="container-fluid align-items-center justify-content-center">
    <a class="notuseramenu" routerLink="/Home.mobile">
      <img src="/assets/logo-mobile.png" class="card-img" [alt]="'Logo' | transloco" height="30" />
    </a>
  </div>
</nav>
